export interface PanAndZoomStoreState {
  translateX: number;
  translateY: number;
  prevMouseX: number;
  prevMouseY: number;
  scale: number;
  prevZoomAddition: number;
  prevZoomDirection: number;
  stepZoomAddition: number;
}

export enum PanAndZoomStoreActionType {
  PAN = 'PAN',
  PAN_START = 'PAN_START',
  ZOOM = 'ZOOM',
  RESET = 'RESET',
}

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 22;

export interface PanAndZoomStoreAction {
  type?: PanAndZoomStoreActionType;
  clientX?: number;
  clientY?: number;
  deltaY?: number;
  containerRect?: DOMRect;
  innerElement?: HTMLElement;
}

export interface PanAndZoomStoreActionBase {
  type: PanAndZoomStoreActionType;
}

export interface PanAndZoomStoreActionPan extends PanAndZoomStoreActionBase {
  clientX: number;
  clientY: number;
  innerElement: HTMLElement;
}

export interface PanAndZoomStoreActionZoom extends PanAndZoomStoreActionBase {
  clientX: number;
  clientY: number;
  deltaY: number;
  containerRect: DOMRect;
}
